<template>
  <div>
    <div style="display: flex;justify-content: center;">
      <div :id="'myChart' + suffix" :style="{width: '800px',height: '400px'}"></div>
    </div>
  </div>
</template>

<script>
import API from "@/../config/api.js";
let myChart;
export default {

  props: ['companyId', 'varId', 'dateRange1', 'dateRange2', 'pageNum', 'pageSize', 'suffix'],
  data() {
    return {
      data: [],
    }
  },
  async mounted() {
    if (myChart != null && myChart != "" && myChart != undefined) {
      myChart.dispose();
    }
    myChart = this.$echarts.init(document.getElementById('myChart' + this.suffix));
    console.log(this.varId);
    await this.initData();
  },
  methods: {
    async initData() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,              //之后删掉
        ids: this.varId,
        dateRange1: this.dateRange1 ? this.dateRange1 : "",
        dateRange2: this.dateRange2 ? this.dateRange2 : "",
      }
      if (this.pageNum) {
        Object.assign(data, {pageNum: this.pageNum});
      }
      if (this.pageSize) {
        Object.assign(data, {pageSize: this.pageSize});
      }
      let ret = await this.$axiosRequest({
        url: API.getVariableHisValueList,  //后面根据端口修改
        method: 'POST',
        data: data,
        header: header,
      })
      this.data = ret[1].data.hisValueList;
      var xData = [], yData = {};
      for (var i = this.data.length - 1; i >= 0; i--) {
        xData.push(this.data[i].updateTime);
        if (!yData[this.data[i].variableName]) yData[this.data[i].variableName] = [];
        yData[this.data[i].variableName].push(this.data[i].variableValue);
      }
      var series = [];
      for (var key in yData) {
        series.push({
          type: 'line',
          name: key,
          data: yData[key]
        })
      }
      console.log(series);
      myChart.setOption({
        tooltip: {},
        xAxis: {
          axisTick: {
            show: false,
          },
          data: xData
        },
        yAxis: {
          type: 'value',
          name: '数值',
          position: 'left',
          //minInterval: 1
        },
        series: series
      });
    }
  },
}
</script>

<style>

</style>
